import { useSelector } from "react-redux";

import type { State } from "reducers";

export const useFeatureFlags = () => {
  const { loading, packages } = useSelector((state: State) => state.userFeatures);

  const hasFAC = packages?.FAC === true;
  const hasPSA = packages?.PSA === true;
  const hasSTU = packages?.STU === true;

  return {
    hasFAC,
    hasPSA,
    hasSTU,
    hasBoth: hasFAC && hasPSA,
    hasEither: hasFAC || hasPSA,
    loading,
  };
};
